:host {
  display: block;
}
:host,
:host *,
:host *::before,
:host *::after {
  box-sizing: border-box;
}
#inner {
  display: flex;
  flex-direction: column;
}
section {
  position: relative;
}
section div:not([inert]) {
  height: inherit;
}
.row > div {
  position: absolute;
}
.row > div > div {
  position: absolute;
  padding-right: 1ch;
  display: flex;
  align-items: center;
}

.row > div:last-child {
  overflow: hidden;
}

.row span:last-child {
  color: var(--theme-tertiary-text);
}
.row span:last-child::before {
  content: '\00A0'; /* non-breaking space */
}

#timeline {
  display: flex;
  flex-direction: column-reverse;
  line-height: 1;
}
.row {
  position: relative;
  font-size: var(--font-size);
  display: flex;
  align-items: center;
}
.row::before {
  content: '\200B'; /* zero-width space to add implicit height */
}
.row > * {
  height: var(--font-size);
}

/* ------------- When 3 rows are visible ------------- */
#timeline[data-visible-rows='3'] .row[data-row='3'] {
  --font-size: 20px;
  font-weight: 600;
  height: 35px;
}
#timeline[data-visible-rows='3'] .row[data-row='3'] span:not(:first-child) {
  --font-size: 14px;
  font-size: var(--font-size);
  font-weight: 500;
  align-self: flex-end;
}
#timeline[data-visible-rows='3'] .row[data-row='2'] {
  --font-size: 12px;
  font-weight: 700;
  height: 29px;
  border-top: 1px solid var(--theme-light-border);
  text-transform: uppercase;
}
#timeline[data-visible-rows='3'] .row[data-row='2'] span:not(:first-child) {
  font-weight: 500;
}
#timeline[data-visible-rows='3'] .row[data-row='1'] {
  --font-size: 11px;
  font-weight: 500;
  height: 25px;
  border-top: 1px solid var(--theme-light-border);
}
#timeline[data-visible-rows='3'] .row[data-row='1'] span:not(:first-child) {
  font-weight: 400;
}

/* ------------- When 2 rows are visible ------------- */
#timeline[data-visible-rows='2'] .row[data-row='2'] {
  --font-size: 18px;
  font-weight: 600;
  height: 35px;
}
#timeline[data-visible-rows='2'] .row[data-row='2'] span:not(:first-child) {
  --font-size: 14px;
  font-size: var(--font-size);
  font-weight: 500;
  align-self: flex-end;
}
#timeline[data-visible-rows='2'] .row[data-row='1'] {
  --font-size: 11px;
  font-weight: 500;
  height: 25px;
  border-top: 1px solid var(--theme-light-border);
}
#timeline[data-visible-rows='2'] .row[data-row='1'] span:not(:first-child) {
  font-weight: 400;
}

/* ------------- When 1 row is visible ------------- */
#timeline[data-visible-rows='1'] .row[data-row='1'] {
  --font-size: 11px;
  font-weight: 500;
  height: 25px;
}
#timeline[data-visible-rows='1'] .row[data-row='1'] span:not(:first-child) {
  font-weight: 400;
}

[inert],
[hidden] {
  visibility: hidden;
  position: absolute;
  pointer-events: none;
  z-index: -1;
}
